<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.2483 3.50049C17.6625 3.50049 17.9983 3.1647 17.9983 2.75049C17.9983 2.33628 17.6625 2.00049 17.2483 2.00049L2.75281 2.00049C2.3386 2.00049 2.00281 2.33627 2.00281 2.75049C2.00281 3.1647 2.3386 3.50049 2.75281 3.50049L17.2483 3.50049Z"
      fill="currentColor"
    />
    <path
      d="M17.2483 17.9994C17.6625 17.9994 17.9983 17.6636 17.9983 17.2494C17.9983 16.8352 17.6625 16.4994 17.2483 16.4994L2.75281 16.4994C2.33859 16.4994 2.00281 16.8352 2.00281 17.2494C2.00281 17.6636 2.33859 17.9994 2.75281 17.9994L17.2483 17.9994Z"
      fill="currentColor"
    />
    <path
      d="M14.0005 4.99939C14.5528 4.99939 15.0005 5.44711 15.0005 5.99939L15.0005 13.9994C15.0005 14.5517 14.5528 14.9994 14.0005 14.9994H6.00053C5.44825 14.9994 5.00053 14.5517 5.00053 13.9994L5.00053 5.99939C5.00053 5.44711 5.44825 4.99939 6.00053 4.99939L14.0005 4.99939Z"
      fill="currentColor"
    />
  </svg>
</template>
